module.exports = __webpack_public_path__ + "img/gambeat_logo_black_full.b581b560.png";